module.exports = __webpack_public_path__ + "img/metal_c@2x.acb1247b.png";